// extracted by mini-css-extract-plugin
export default {"titleActions":"aliasPreferences_titleActions__S2R9E","tableContainer":"aliasPreferences_tableContainer__W6axf"};